(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('BankAccountInfoCustom', BankAccountInfoCustom);

    BankAccountInfoCustom.$inject = ['$resource'];

    function BankAccountInfoCustom($resource) {


        var findBankAccountInfoByCurrentCompnay = function () {

            var resourceUrl = 'api/find-bank-account-info-by-current-company';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        return {
            findBankAccountInfoByCurrentCompnay: findBankAccountInfoByCurrentCompnay
        };
    }
})();
